var _G, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
function SvgFlagInactive(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#flag-inactive_svg__clip0_10360_5363)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M47.502 17.5l7.553-10.026a4.64 4.64 0 00.448-4.891A4.64 4.64 0 0051.326 0H9.333C4.186 0 0 4.186 0 9.333v44.334a2.333 2.333 0 104.667 0V35h46.662a4.644 4.644 0 004.176-2.583 4.641 4.641 0 00-.448-4.89L47.502 17.5zM4.667 30.333v-21a4.671 4.671 0 014.666-4.666H51.33l-8.61 11.428a2.334 2.334 0 000 2.807l8.61 11.429H4.667v.002z",
    fill: "#676D7D"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "flag-inactive_svg__clip0_10360_5363"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
}
export default SvgFlagInactive;